export enum SalesDocumentsDateSelectionKind {
    None = 'None',
    IssueDate = 'IssueDate',
    DeliveryDate = 'DeliveryDate',
    TaxLiabilityDate = 'TaxLiabilityDate'
}
